import { fa } from 'vuetify/iconsets/fa-svg';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import defaultTheme from '@/modules/vuetify/themes/defaultTheme';
import { VDateInput } from 'vuetify/labs/VDateInput';
import { VTimePicker } from 'vuetify/labs/VTimePicker';
import { VTreeview } from 'vuetify/labs/VTreeview';

import {
    mdiDeleteOutline,
    mdiPencilOutline,
    mdiMagnify,
    mdiMenuUp,
    mdiMenuDown,
    mdiChevronRight,
    mdiChevronLeft,
    mdiPlus,
    mdiAlertCircleOutline,
    mdiEyeOutline,
    mdiEyeOffOutline,
    mdiCogOutline,
    mdiLockOutline,
    mdiAccountMultipleOutline,
    mdiViewDashboardOutline,
    mdiAccountTie,
    mdiInvoiceListOutline,
    mdiStoreOutline,
    mdiListBoxOutline,
    mdiCloverOutline,
    mdiAccountOutline,
    mdiEmailOutline,
    mdiClockOutline,
    mdiPartyPopper,
    mdiCalendarRange,
    mdiExport,
} from '@mdi/js';
import { createVuetify } from 'vuetify';

export const install = (app: any) => {
    const vuetify = createVuetify({
        icons: {
            defaultSet: 'mdi',
            aliases: {
                ...aliases,
                'delete': mdiDeleteOutline,
                'edit': mdiPencilOutline,
                'search': mdiMagnify,
                'up': mdiMenuUp,
                'down': mdiMenuDown,
                'right': mdiChevronRight,
                'left': mdiChevronLeft,
                'add': mdiPlus,
                'alert' : mdiAlertCircleOutline,
                'show': mdiEyeOutline,
                'hide': mdiEyeOffOutline,
                'settings': mdiCogOutline,
                'lock': mdiLockOutline,
                'users': mdiAccountMultipleOutline,
                'dashboard': mdiViewDashboardOutline,
                'admin': mdiAccountTie,
                'invoices': mdiInvoiceListOutline,
                'store': mdiStoreOutline,
                'list': mdiListBoxOutline,
                'clover': mdiCloverOutline,
                'user': mdiAccountOutline,
                'email': mdiEmailOutline,
                'clock': mdiClockOutline,
                'calendar': mdiCalendarRange,
                'party': mdiPartyPopper,
                'export': mdiExport,
            },
            sets: { fa, mdi },
        },
        theme: {
            defaultTheme: 'defaultTheme',
            themes: {
                defaultTheme,
                dark: {}
            }
        }
    });

    app.component('v-date-input', VDateInput);
    app.component('v-time-picker', VTimePicker);
    app.component('v-treeview', VTreeview);
    app.use(vuetify);
};
